/**
 * Convert user input date string to ISO-compatible date string
 * @param {String} dateString - user input in format DD.MM.YYYY
 * @returns {String} - ISO-compatible string in format YYYY-MM-DD
 */
export const userDateToIsoDate = (dateString: string): string => {
  const dateParts = 3
  const [day, month, year] = dateString.split('.', dateParts)
  if (!day || !month || !year) {
    throw new Error('Invalid date')
  }

  return `${year}-${month}-${day}`
}
